import AppLayout from "../layout/AppLayout";
import {
  IntroBanner,
  Brief,
  Values,
  Goals,
  WeLove,
  Teams,
  Seo,
} from "../components";

const ABOUT_DESC =
  "Get to know QBIT, an Indonesia-based creative technology solution provider. We develop products and projects with unique, creative solutions that meet our clients' business objectives.";

export default function AboutUs() {
  return (
    <AppLayout withoutContainer>
      <Seo title="About Us" description={ABOUT_DESC} path="/about-us" />
      <IntroBanner
        title="About Us"
        desc="We develop product and project with unique and creative solutions that meet the client's expectations not only by realizing the client's business objectives, but also by considering the effective approach in IT solution."
      />
      <Brief />
      <Values />
      <Goals />
      <Teams />
      <WeLove />
    </AppLayout>
  );
}
